import React from 'react';

import { t } from 'i18next';

import { ADD_PERSON, CLOSE_ICON, EMAIL, TRASH_V3 } from '../../../constants/images';
import { IActionBar } from '../../../interfaces/actionBar';
import { TRANSLATION_COLLABORATORS } from '../../../translations/collaborators';
import BdsTooltip from '../BdsTooltip/BdsTooltip';
import BdsIconButton from '../Buttons/BdsIconButton/BdsIconButton';

import './ActionBar.scss';

const ActionBar = ({
  text,
  deleteTooltip = TRANSLATION_COLLABORATORS.table.tooltips.deleteCollaborator,
  onPressAdd,
  onPressDelete,
  onPressEmail,
  onPressX,
  onPressIgnore
}: IActionBar) => {
  const renderContent = () => {
    return (
      <div className="action-bar">
        <div className="close-icon">
          {<BdsIconButton icon={CLOSE_ICON} action={onPressX} variant="inverse" size="sm" label="close" />}
        </div>
        <div className="action-bar-text">{text}</div>
        <div className="last-icons">
          {onPressAdd && (
            <BdsTooltip
              message={t(TRANSLATION_COLLABORATORS.table.tooltips.addCollaborator)}
              position="bottom-right"
              variant="inverse"
            >
              <BdsIconButton
                className="add-person-icon"
                icon={ADD_PERSON}
                action={onPressAdd}
                variant="primary"
                size="sm"
                label="add"
              />
            </BdsTooltip>
          )}

          {onPressIgnore && (
            <BdsTooltip
              message={t(TRANSLATION_COLLABORATORS.table.tooltips.deletePending)}
              position="bottom-right"
              variant="inverse"
            >
              <BdsIconButton icon={TRASH_V3} action={onPressIgnore} variant="primary" size="sm" label="ignore" />
            </BdsTooltip>
          )}
          {onPressDelete && (
            <BdsTooltip message={t(deleteTooltip)} position="bottom-right" variant="inverse">
              <BdsIconButton icon={TRASH_V3} action={onPressDelete} variant="primary" size="sm" label="delete" />
            </BdsTooltip>
          )}
          {onPressEmail && (
            <BdsTooltip
              message={t(TRANSLATION_COLLABORATORS.table.tooltips.resendEmail)}
              position="bottom-right"
              variant="inverse"
            >
              <BdsIconButton icon={EMAIL} action={onPressEmail} variant="primary" size="sm" label="email" />
            </BdsTooltip>
          )}
        </div>
      </div>
    );
  };

  return <span className={'action-bar'}>{renderContent()}</span>;
};

export default ActionBar;
